<template>
	<div class="gb-header-calendar">
		<div v-bind:style="styleInner" style="position: relative"
			v-bind:class="classInner"
			v-statemachine= "statemachine"
			class="gb-header-calendar-label"
		>
			<GBMonth
				v-for="ym in this.$store.getters.calendar_yearmonth"
				v-bind:key="ym.code"
				v-bind:month="ym"
				v-on:show-free-persons="onShowFreePersons"
			/>
			<transition
				name="fade"
				@after-enter="transitionCallBack"
			>
				<div v-show="$store.getters.isScrollingToToday" class="transition-move-to-today"></div>
			</transition>
		</div>
	</div>
</template>
<script>
import GBMonth from './GBMonth';
import MouseState from '../classes/MouseState';
import MouseStateMachine from '../classes/MouseStateMachine';

export default {
	name: 'GBHeaderCalendar',
	components: {
		GBMonth,
	},
	data: function() {
		const state_default = new MouseState({
			down: (e) => {
				this.$emit('hscroll-start', {
					x: e.pageX,
				});
			},
		});
		return {
			statemachine: new MouseStateMachine(state_default),
		};
	},
	methods: {
		transitionCallBack:function(){
			this.$store.dispatch('setScrollingToToday', false);
		},
		onShowFreePersons: function(e) {
			this.$emit("show-free-persons", e);
		},
	},
	computed: {
		styleInner: function() {
			return {
				'width': this.$store.getters.innerWidth + 'px',
				'left': (- this.$store.getters.hscroll) + 'px',
			}
		},
		classInner: function(){
			if(this.$store.getters.isScrollingToToday){
				return "transition-move-to-today";
			}
			return "";
		},
	},
};

</script>
<style>
	.gb-header-calendar {
		width: 100%;
		height: 89px;
		overflow: hidden;
	}
</style>
